import { Badge, Box, Flex, Stack, StackDivider, Text } from '@chakra-ui/react';

import { ItemNovidade, TipoNovidade, VersaoNovidades } from '../../data/novidades';

const ETIQUETAS: Record<TipoNovidade, { rotulo: string; colorScheme: string }> = {
	novidade: { rotulo: 'Novidade', colorScheme: 'blue' },
	melhoria: { rotulo: 'Melhoria', colorScheme: 'green' },
	correcao: { rotulo: 'Correção', colorScheme: 'orange' },
	seguranca: { rotulo: 'Segurança', colorScheme: 'purple' }
};

/** `2026-08-03` vira `3 de agosto de 2026`. O horario evita o fuso comer um dia. */
export const formatarData = (iso: string) =>
	new Date(`${iso}T00:00:00`).toLocaleDateString('pt-BR', { day: 'numeric', month: 'long', year: 'numeric' });

export const EtiquetaNovidade = ({ tipo }: { tipo: TipoNovidade }) => {
	const { rotulo, colorScheme } = ETIQUETAS[tipo];

	return (
		<Badge colorScheme={colorScheme} fontSize="11px" flexShrink={0}>
			{rotulo}
		</Badge>
	);
};

/** Uma mudanca do mural: etiqueta, titulo e a explicacao em linguagem de quem usa. */
export const CardNovidade = ({ item }: { item: ItemNovidade }) => {
	return (
		<Flex direction="column" gap="6px">
			<Flex align="center" gap="10px" wrap="wrap">
				<EtiquetaNovidade tipo={item.tipo} />
				<Text fontSize="15px" fontWeight="700" color="ink">
					{item.titulo}
				</Text>
			</Flex>
			<Text fontSize="14px" fontWeight="400" color="gray.600" lineHeight="1.6">
				{item.descricao}
			</Text>
		</Flex>
	);
};

type ListaNovidadesProps = {
	versoes: VersaoNovidades[];
	/** Corta a lista nos primeiros itens, para o resumo do dashboard. */
	limite?: number;
	/** Esconde titulo, data e resumo da entrega, deixando so os itens. */
	semCabecalho?: boolean;
};

/**
 * As entregas na ordem do mais recente para o mais antigo. Usada inteira na
 * pagina de novidades e cortada pelo `limite` no painel do dashboard.
 */
export const ListaNovidades = ({ versoes, limite, semCabecalho }: ListaNovidadesProps) => {
	return (
		<Flex direction="column" gap="24px">
			{versoes.map((versao) => {
				const itens = limite ? versao.itens.slice(0, limite) : versao.itens;

				return (
					<Flex key={versao.data} direction="column" gap="14px">
						{!semCabecalho && (
							<Flex direction="column" gap="4px">
								<Flex align="baseline" gap="10px" wrap="wrap">
									<Text fontFamily="heading" fontSize="20px" fontWeight="700" color="ink" textTransform="uppercase">
										{versao.versao}
									</Text>
									<Text fontSize="13px" fontWeight="500" color="gray.500">
										{formatarData(versao.data)}
									</Text>
								</Flex>
								<Text fontSize="14px" fontWeight="400" color="gray.600" lineHeight="1.6">
									{versao.resumo}
								</Text>
							</Flex>
						)}
						<Box borderLeft="2px solid" borderColor="mist" pl="16px">
							<Stack spacing="16px" divider={<StackDivider borderColor="mist" />}>
								{itens.map((item) => <CardNovidade key={item.id} item={item} />)}
							</Stack>
						</Box>
					</Flex>
				);
			})}
		</Flex>
	);
};
